<template>
	<Link :title="link.title" :url="url" :target="link.target" :className="'lang ' + className" />
</template>

<script>
import Link from '../partials/Link.vue'
export default {
	name: 'LangLink',
	components: { Link },
	props: {
		link: null,
		className: {
			type: String,
			default: '',
		},
	},
	computed: {
		url() {
			var link = this.link.url
			if (window.location.href.includes('majestic.dev')) {
				link = this.link.staging
			} else if (
				window.location.href.includes('live-en-site') ||
				window.location.href.includes('live-fr-site')
			) {
				link = this.link.live
			}
			return link
		},
	},
}
</script>